import { StaticImageData } from 'next/image';
import 전체 from '/public/static/images/categories/asian-food.webp';
import 태국 from '/public/static/images/categories/asian-food.webp';
import 치킨 from '/public/static/images/categories/chicken.webp';
import 중식 from '/public/static/images/categories/china-food.webp';
import 카페디저트 from '/public/static/images/categories/coffee.webp';
import 감자탕 from '/public/static/images/categories/gamzatang.webp';
import 버거 from '/public/static/images/categories/hamburger.webp';
import 족발보쌈 from '/public/static/images/categories/jok-bo.webp';
import 한식 from '/public/static/images/categories/korea-food.webp';
import 마라탕 from '/public/static/images/categories/maratang.webp';
import 밀크티 from '/public/static/images/categories/milk-tea.webp';
import 피자양식 from '/public/static/images/categories/pizza.webp';
import 고기구이 from '/public/static/images/categories/pork-belly.webp';
import 회초밥 from '/public/static/images/categories/sushi.webp';

export type TCategory = {
  label: string;
  key: string;
  imgUrl: string;
  type: 'category' | 'search';
  image: StaticImageData;
};

const CATEGORIES: TCategory[] = [
  {
    label: 'all',
    key: '전체',
    imgUrl: '/static/images/categories/all.png',
    type: 'category',
    image: 전체,
  },
  {
    label: 'chicken',
    key: '치킨',
    imgUrl: '/static/images/categories/chicken2.png',
    type: 'category',
    image: 치킨,
  },
  {
    label: 'pizza',
    key: '피자양식',
    imgUrl: '/static/images/categories/img_pizza.png',
    type: 'category',
    image: 피자양식,
  },
  {
    label: 'bugger',
    key: '버거',
    imgUrl: '/static/images/categories/burger2.png',
    type: 'category',
    image: 버거,
  },
  {
    label: 'cafe/dessert',
    key: '카페디저트',
    imgUrl: '/static/images/categories/cake2.png',
    type: 'category',
    image: 카페디저트,
  },
  {
    label: 'milktea',
    key: '밀크티',
    imgUrl: '/static/images/categories/Cha32.png',
    type: 'search',
    image: 밀크티,
  },
  {
    label: 'rawfish/sushi',
    key: '회초밥',
    imgUrl: '/static/images/categories/sushi2.png',
    type: 'category',
    image: 회초밥,
  },
  {
    label: 'pigfeet/bossam',
    key: '족발보쌈',
    imgUrl: '/static/images/categories/jokbal2.jpg',
    type: 'category',
    image: 족발보쌈,
  },
  {
    label: 'chinesefood',
    key: '중식',
    imgUrl: '/static/images/categories/zzam2.png',
    type: 'category',
    image: 중식,
  },
  {
    label: 'grilledmeat',
    key: '고기구이',
    imgUrl: '/static/images/categories/pork-belly.webp',
    type: 'category',
    image: 고기구이,
  },
  {
    label: 'koreanfood',
    key: '한식',
    imgUrl: '/static/images/categories/korean2.png',
    type: 'category',
    image: 한식,
  },
  {
    label: 'porkbackbonestew',
    key: '감자탕',
    imgUrl: '/static/images/categories/gamzatang.webp',
    type: 'search',
    image: 감자탕,
  },
  {
    label: 'malatang',
    key: '마라탕',
    imgUrl: '/static/images/categories/maratang.webp',
    type: 'search',
    image: 마라탕,
  },
  {
    label: 'thai',
    key: '태국',
    imgUrl: '/static/images/categories/tah.png',
    type: 'search',
    image: 태국,
  },
];

export default CATEGORIES;
